import { tv } from 'tailwind-variants';

export const uploadButtonStyle = tv({
  base: 'grid w-fit items-center justify-center px-4 text-sm cursor-pointer transition-all duration-300 hover:opacity-60',
  variants: {
    design: {
      bordered: '',
      admin: '',
      trader: '',
      unbordered: '',
      custom: '',
    },
    errored: {
      true: 'border-primary-two text-primary-two',
    },
    disabled: {
      true: 'cursor-not-allowed border-zinc-100 text-zinc-100 hover:opacity-100',
    },
    textTransform: {
      uppercase: 'uppercase',
      lowercase: 'lowercase',
      capitalize: 'capitalize',
      none: '',
    },
  },
  defaultVariants: {
    design: 'bordered',
    fontWeight: 'normal',
    textTransform: 'uppercase',
  },
  compoundVariants: [
    {
      design: 'custom',
      disabled: true,
      className: 'hover:opacity-60 opacity-60',
    },
  ],
});
